module.exports = __webpack_public_path__ + "img/news.f2304579.png";